import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, YAxis, XAxis, ReferenceLine } from 'recharts';
import SignedBarChartLabel from './SignedBarChartLabel';
import SignedBarChartAxisLabel from './SignedBarChartAxisLabel';
import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

export const sum = data => data.reduce((acc, { value } = {}) => acc + value, 0);

export const formatData = data => {
  if (!data[0].length || !data[1].length) return [];

  const totals = [sum(data[0]), sum(data[1])];

  return data[0].map((plusData, i) => ({
    name: plusData.name,
    plus: ((plusData.value / totals[0]) * 100).toFixed(0),
    minus: -((data[1][i].value / totals[1]) * 100).toFixed(0),
  }));
};

const SignedBarChartData = ({ colors, data, sectionTitle }) => {
  const yAxisProps = {
    dataKey: 'name',
    type: 'category',
    tickSize: 0,
  };

  return (
    <div className="section-graph">
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">{sectionTitle}</h4>
      </ViewerPrimaryColorUserStyle>
      <BarChart
        width={300}
        height={200}
        data={formatData(data)}
        layout="vertical"
        stackOffset="sign"
        className="signed-bar-chart-data"
        barSize={20}
      >
        <XAxis
          domain={['dataMin - 25', 'dataMax + 25']}
          type="number"
          tickSize={0}
          tick={false}
          label={<SignedBarChartAxisLabel />}
        />
        <YAxis
          {...yAxisProps}
          orientation="left"
          yAxisId="left"
          tick={{ transform: 'translate(-10, 0)' }}
        />
        <YAxis
          {...yAxisProps}
          orientation="right"
          yAxisId="right"
          tick={{ transform: 'translate(10, 0)' }}
        />

        <ReferenceLine x={0} stroke="#aaa" isFront />

        <Bar
          dataKey="minus"
          stackId="stack"
          yAxisId="left"
          label={<SignedBarChartLabel />}
          fill={colors[0].toString()}
        />
        <Bar
          dataKey="plus"
          stackId="stack"
          yAxisId="left"
          label={<SignedBarChartLabel />}
          fill={colors[4].toString()}
        />
      </BarChart>
    </div>
  );
};

SignedBarChartData.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string]))
  .isRequired,
  data: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
  sectionTitle: PropTypes.string,
};

export default SignedBarChartData;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/SignedBarChart/SignedBarChart.js